document.addEventListener("DOMContentLoaded", function () {

  const lightbox = document.getElementById("lightbox");
  const lightboxImg = document.getElementById("lightbox-img");
  const closeBtn = document.querySelector(".lightbox-close");

  if (!lightbox || !lightboxImg) return;

  // Open lightbox
  document.querySelectorAll("[data-lightbox]").forEach(img => {
    img.addEventListener("click", function () {
      lightboxImg.src = this.src;
      lightbox.classList.add("active");
    });
  });

  // Close on background click
  lightbox.addEventListener("click", function (e) {
    if (e.target === lightbox) {
      lightbox.classList.remove("active");
    }
  });

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      lightbox.classList.remove("active");
    });
  }

  // ESC key support
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      lightbox.classList.remove("active");
    }
  });

});
